export default "__VITE_ASSET__Db343lHI__"